module.exports = __webpack_public_path__ + "img/t4ever.1fb82a03.png";